import { applyMerge, applyDim, applyScalar } from "./apply.js";
const divideOp = (a, b) => a / b;
/**
 * @internal
 * @param a
 * @param b
 * @param c
 * @returns
 */
export function divide(a, b, c) {
    // @ts-ignore
    return applyMerge(divideOp, a, b, c);
}
/**
 * Divides all components of `rect` by `amount`.
 * This includes x,y if present.
 *
 * ```js
 * divideScalar({ width:10, height:20 }, 2); // { width:5, height: 10 }
 * divideScalar({ x: 1, y: 2, width:10, height:20 }, 2); // { x: 0.5, y: 1, width:5, height: 10 }
 * ```
 * @param rect
 * @param amount
 */
export function divideScalar(rect, amount) {
    return applyScalar(divideOp, rect, amount);
}
export function divideDim(rect, amount) {
    return applyDim(divideOp, rect, amount);
}
